import { ref, type Ref } from 'vue';
import { useCustomToast, sanitizeIntegerInput } from '@/shared/lib';

const VALIDATION_ERROR_TITLE = 'Erro de validação';

export default function useDocumentUrlUpload() {
  const urlValue = ref('');
  const numbering = ref(0);
  const sequential = ref(0);
  const changelog = ref('');
  const documentName = ref('');
  const isSubmitting = ref(false);

  const toast = useCustomToast();

  const incrementNumbering = () => numbering.value++;
  const decrementNumbering = () => {
    if (numbering.value > 0) numbering.value--;
  };

  const incrementSequential = () => sequential.value++;
  const decrementSequential = () => {
    if (sequential.value > 0) sequential.value--;
  };

  const handleIntegerInput = (target: Ref<number>) => (event: Event) => {
    const input = event.target as HTMLInputElement;
    target.value = sanitizeIntegerInput(input.value);
    input.value = String(target.value);
  };

  const handleNumberingInput = handleIntegerInput(numbering);
  const handleSequentialInput = handleIntegerInput(sequential);

  const validateForm = (prefixId: number | string, userId: number | string): boolean => {
    if (!urlValue.value.trim()) {
      toast.showErrorToast({
        title: VALIDATION_ERROR_TITLE,
        message: 'URL é obrigatória',
        type: 'error',
      });
      return false;
    }

    if (!prefixId) {
      toast.showErrorToast({
        title: VALIDATION_ERROR_TITLE,
        message: 'Prefixo é obrigatório',
        type: 'error',
      });
      return false;
    }

    if (!userId) {
      toast.showErrorToast({
        title: VALIDATION_ERROR_TITLE,
        message: 'Responsável pela aprovação é obrigatório',
        type: 'error',
      });
      return false;
    }

    if (!changelog.value.trim()) {
      toast.showErrorToast({
        title: VALIDATION_ERROR_TITLE,
        message: 'Changelog é obrigatório',
        type: 'error',
      });
      return false;
    }

    if (changelog.value.length > 2000) {
      toast.showErrorToast({
        title: VALIDATION_ERROR_TITLE,
        message: 'O changelog não pode exceder 2000 caracteres',
        type: 'error',
      });
      return false;
    }

    return true;
  };

  return {
    urlValue,
    numbering,
    sequential,
    changelog,
    documentName,
    isSubmitting,
    incrementNumbering,
    decrementNumbering,
    incrementSequential,
    decrementSequential,
    sanitizeIntegerInput,
    handleNumberingInput,
    handleSequentialInput,
    validateForm,
  };
}
